<template>
  <card
    v-if="!isLoadingImages"
    :style="[
      isLarge
        ? {
            'max-width': '28rem',
            height: '40rem',
            'max-height': '43rem',
            'border-radius': '10px',
          }
        : {
            'max-width': '28rem',
            'max-sheight': '45rem',
            'border-radius': '10px',
          },
    ]"
    class="postcardattivita attivita p-0 orange"
    :class="isLarge ? 'mx-2' : ''"
  >
    <div>
      <slider
        class="custom-image-slider"
        animation="fade"
        :autoplay="false"
        v-if="item.mediaImages !== undefined && item.mediaImages.length !== 0"
      >
        <slider-item v-for="(media, index) in item.mediaImages" :key="index">
          <img
            v-img="{ group: screenSize + indexOfActivity }"
            :src="media['o:thumbnail_urls']['large']"
            :alt="item['o:title']"
            class="img"
          />
        </slider-item>
      </slider>
      <slider
        class="custom-image-slider"
        animation="fade"
        :autoplay="false"
        v-else
      >
        <slider-item>
          <img
            v-img="{ group: screenSize + indexOfActivity }"
            :src="require('@/assets/images/noPhotoAvailable.png')"
            alt="Esperimento"
            class="img"
          />
        </slider-item>
      </slider>
      <div class="mt-3">
        <h5 class="card-title text-center">
          <b>Visita {{ item["geo:Titolo_it"][0]["@value"] }}</b>
        </h5>

        <div class="postcardattivita__tagbox mb-4">
          <button
            :class="
              selectedTab === 'Panoramica'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Panoramica'"
          >
            Panoramica
          </button>
          <button
            :class="
              selectedTab === 'Descrizione'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Descrizione'"
          >
            Descrizione
          </button>
          <!-- <button
            :class="
              selectedTab === 'Immagini'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Immagini'"
          >
            Immagini
          </button> -->
        </div>

        <div :class="{ 'text-justify ': !isMobile }">
          <div v-if="selectedTab === 'Panoramica'" class="col-12">
            <div
              class="text-left description col-12 text-black text mt-3 overflow-auto"
            >

            <div class="row text-center">
                  <div class="col-6" style="border-right: 1px ridge">
                    <div class="row text-center">
                      <div class="col-12">
                        <i class="bi bi-pin-map-fill mr-2"></i>
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col-12">
                        <h5 style="font-weight: 600">
                          {{
                            item["geo:Titolo_it"][0]["@value"]
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row text-center">
                      <div class="col-12">
                        <i class="bi bi-clock mr-2"></i>
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col-12">
                        <h5 style="font-weight: 600">
                          {{ item["geo:Durata"][0]["@value"] }} minuti
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

              
            </div>
          </div>
          <div v-else-if="selectedTab === 'Descrizione'" class="col-12">
            <div
              class="text-justify description col-12 text-black text mt-3 overflow-auto"
            >
              <div v-if="item['dcterms:description']">
                <b>{{ item["dcterms:description"][0]["@value"] }}</b>
              </div>
              <div v-else>Nessun descrizione disponibile</div>

              <div class="mt-3" v-if="item['geo:Scheda_esterna']">
                <h6 class="font-weight-normal">
                  <div class="row" v-for="(link, index) in item['geo:Scheda_esterna']" :key="link['@value']" :class="index > 0 ? 'mt-2' : ''">
                    <div class="col-12">
                      <a :href="getLink(link['@value'])" style="color: #5486a8 !important;" target="_blank"
                      >{{getLinkName(link['@value'])}}</a
                      >
                    </div>
                  </div>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
import $ from "jquery";

import TabPane from "../Tabs/Tab.vue";
import Tabs from "../Tabs/Tabs.vue";
import Card from "../Cards/Card.vue";

import { Carousel, Slide } from "vue-carousel";

import { Slider, SliderItem } from "vue-easy-slider";


import { isMobile } from "mobile-device-detect";

import { config } from "../../utils/config";

const Common = require("@/Common.vue").default;

export default {
  name: "visita",
  props: ["item", "indexOfActivity", "screenSize"],

  components: {
    Card,
    Slider,
    SliderItem,
  },


  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
    };
  },
  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });
  },

  methods: {
    getInterestList(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"]);
      }

      return newList;
    },
    getLink(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[1];
      } else {
        return link;
      }
    },
    getLinkName(link){
      if(link.split('~').length > 1) {
        var split = link.split('~');
        return split[0];
      } else {
        return "Dettagli";
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    player() {
      return this.$refs.youtube.player;
    },
    isLarge() {
      return this.windowWidth >= 768;
    },
    getYoutubeVideoID() {
      var url = this.item["mediaYT"][0]["o:source"];
      return url.substring(url.indexOf("=") + 1);
    },
  },

  mounted() {
    this.isMobile = isMobile;

    var self = this;

    Common.getElementImages(this, this.item, (mediaList) => {
      this.item.media = mediaList;
      self.isLoadingImages = false;
    });

    Common.getElementYTVideos(this, this.item, (ytVideoList) => {
      this.item.mediaYT = ytVideoList;
      self.isLoadingVideos = false;
    });
  },
};
</script>

<style scoped>
.img_esperimento {
  width: 80%;
  object-fit: cover;
}

@media only screen and (max-width: 768px) {
  .carouselImage {
    height: 25vh;
    width: 100%;
  }

  #carousel-1 {
    width: 75%;
  }

  .carousel-control-prev {
    margin-left: -50px;
  }

  .carousel-control-next {
    margin-right: -50px;
  }
}

@media only screen and (min-width: 768px) {
  .carouselImage {
    height: 50vh;
    width: 100%;
  }

  #carousel-1 {
    width: 50%;
  }

  .carousel-control-prev {
    margin-left: -100px;
  }

  .carousel-control-next {
    margin-right: -100px;
  }
}

/*
@media only screen and (min-width: 640px){
  iframe{
    width: 640px;
    height:360px;
  }
}
@media only screen and (max-width: 640px){
  iframe{
    width: 100%;
    aspect-ratio:64/36;
  }
}

 */

.VueCarousel-dot-container {
  margin-top: 0 !important;
}

.img {
  align-items: center;
  width: 100%;
  object-fit: cover;
  /* cover makes the image stretch the width and height of the container */
  margin-top: auto;
  margin-bottom: auto;
}

.text {
  height: 13rem;
  overflow: scroll;
  /*text-overflow: ellipsis;*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
</style>